module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/day03_08_stay-55c9c3f0316506b2cf49ea121f29ba9d.jpg";